const initialState ={
    forms: []
}

export const formsReducer=(state=initialState, action) => {
    
    switch (action.type) {
        case 'GET_ALL_FORMS' : return{
            ...state,
            forms : action.payload
        }
        default : return state
    }
}